import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Resizable } from "re-resizable";
import { globalMenu } from "@shared/libs/Global";

interface SnResizableProps {
  id: string;
  direction: "height" | "width";
  orgSize: string;
  children?: React.ReactNode;
}

export const SnResizable = forwardRef(
  ({ id, direction, orgSize, children }: SnResizableProps, ref) => {
    const { activeMenuInfo } = globalMenu();
    const cdMenu = activeMenuInfo.cd_menu;

    const [size, setSize] = useState<string>();

    /***************************************
     * imperative handle
     ***************************************/
    useImperativeHandle(
      ref,
      () => ({
        getSize: () => size,
      }),
      [size, orgSize]
    );

    // 최초 로딩
    useEffect(() => {
      const menuSize = localStorage.getItem("menuSize");

      if (menuSize) {
        const parsed = JSON.parse(menuSize);
        if (parsed[cdMenu] && parsed[cdMenu][id]) {
          setSize(parsed[cdMenu][id]);
        } else {
          setSize(orgSize);
        }
      } else {
        setSize(orgSize);
      }
    }, [orgSize, cdMenu, id]);

    // Resize Stop
    const handleResizeStop = (
      event: MouseEvent | TouchEvent,
      dir: string,
      refEl: HTMLElement
    ) => {
      const newSize =
        direction === "height" ? refEl.style.height : refEl.style.width;

      setSize(newSize);
    };

    // height / width 핸들러
    const handleComponent =
      direction === "height"
        ? {
            bottom: (
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "12px",
                  cursor: "ns-resize",
                  background: "transparent",
                }}
              />
            ),
          }
        : {
            right: (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  height: "100%",
                  width: "12px",
                  cursor: "ew-resize",
                  background: "transparent",
                }}
              />
            ),
          };

    return (
      <Resizable
        size={direction === "height" ? { height: size } : { width: size }}
        minHeight="100px"
        minWidth="100px"
        onResizeStop={handleResizeStop}
        enable={direction === "height" ? { bottom: true } : { right: true }}
        handleComponent={handleComponent}
        style={{ position: "relative" }}
      >
        {children}
      </Resizable>
    );
  }
);

export default React.memo(SnResizable);
